import { render, staticRenderFns } from "./sec-modulos.vue?vue&type=template&id=614210b6&scoped=true&"
import script from "./sec-modulos.vue?vue&type=script&lang=js&"
export * from "./sec-modulos.vue?vue&type=script&lang=js&"
import style0 from "./sec-modulos.vue?vue&type=style&index=0&id=614210b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614210b6",
  null
  
)

export default component.exports